import { BaseApiRequest } from "./BaseApi";

// Configuration
const BATCH_INTERVAL = 5000; // 5 seconds in milliseconds
const LOG_QUEUE_KEY = 'app_log_queue';

// Initialize queue and timer
let logQueue = [];
let flushTimer = null;

// Initialize queue from sessionStorage if available
function initializeQueue() {
  try {
    const storedQueue = sessionStorage.getItem(LOG_QUEUE_KEY);
    if (storedQueue) {
      logQueue = JSON.parse(storedQueue);
    }
  } catch (err) {
    console.error('Failed to load log queue from session storage:', err);
  }
}

// Save queue to sessionStorage
function saveQueue() {
  try {
    sessionStorage.setItem(LOG_QUEUE_KEY, JSON.stringify(logQueue));
  } catch (err) {
    console.error('Failed to save log queue to session storage:', err);
  }
}

// Flush logs to the API
async function flushLogs() {
  if (logQueue.length === 0) {
    return;
  }

  const logsToSend = [...logQueue];
  logQueue = [];
  saveQueue();

  try {
    await callApi(logsToSend);
  } catch (err) {
    console.error('Failed to send logs:', err);
    // Re-add failed logs back to queue
    logQueue = [...logsToSend, ...logQueue];
    saveQueue();
  }
}

// Start the automatic flush timer
function startFlushTimer(interval = BATCH_INTERVAL) {
  if (flushTimer) {
    clearInterval(flushTimer);
  }
  
  flushTimer = setInterval(() => {
    flushLogs();
  }, interval);
}

// Stop the automatic flush timer
function stopFlushTimer() {
  if (flushTimer) {
    clearInterval(flushTimer);
    flushTimer = null;
  }
}

// Add a log entry to the queue
function queueLogEntry(level, message, error, properties) {
  const logEntry = {
    level: level,
    renderedMessage: message,
    timestamp: new Date().toISOString(), // Use ISO string for serialization
    exception: error ? JSON.stringify(error) : null,
    properties: properties
  };

  logQueue.push(logEntry);
  saveQueue();
}

function logMessage(level, message, error, properties) {
  queueLogEntry(level, message, error, properties);
}

const callApi = (requestObj) => {
  return BaseApiRequest(null, `/serilogging`, "logging", "POST", requestObj, {
    'Content-type': "application/json",
    'LoggingHostName': "GPRLive-UI"
  });
}

function logInfo(message, error, properties) {
  logMessage("Information", message, error, properties);
}

function logDebug(message, error, properties) {
  logMessage("Debug", message, error, properties);
}
  
function logEvent(message, error, properties) {
  logMessage("Event", message, error, properties);
}
  
function logError(error, message, properties) {
  logMessage("Error", message ?? "Error was thrown", error, properties);
}
  
function logWarn(message, error, properties) {
  logMessage("Warning", message, error, properties);
}

// Initialize the logging system
initializeQueue();
startFlushTimer();

// Flush logs when the page is about to unload
window.addEventListener('beforeunload', () => {
  stopFlushTimer();
  flushLogs();
});

export { 
  logEvent, 
  logError, 
  logInfo, 
  logMessage, 
  logWarn, 
  logDebug,
  flushLogs, // Export for manual flushing if needed
  startFlushTimer, // Export to reconfigure interval
  stopFlushTimer // Export to stop logging
};